import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { compose } from "recompose";
import UnattendedDelivery from "../../../../Common/UnattendedDelivery";
import useUpdateOrRemoveQueryParams from '../../../../../../routes/utils/useUpdateOrRemoveQueryParams';
import { formatAddress } from '../../../utils/utils';
import CustomerMergeIndicator from "../../../../../common/CustomerMergeIndicator";

const styles = (theme) => ({
  stopDetailsContainer: {
    marginTop: 12,
  },
  stopHeaderContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  stopName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    display:"flex",
    alignItems:"center",
    gap:"10px"
  },
  stopAddress: {
    color: theme.subHeaderTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
  },
  showUnderLineText: {
    textDecorationLine: 'underline',
    cursor: 'pointer'
  }
});

const StopDetailsTitle = ({
  classes,
  theme,
  stopData,
  driverNumber,
  isUnattendedDelivery,
  enableCustomerLink,
  showCustomerCode
}) => {
  const updateOrRemoveQueryParams = useUpdateOrRemoveQueryParams();
  const {
    displayCustomerName: stopName,
    name,
    accountNumber: customerCode,
    address,
    address2,
    city,
    state,
    zip,
    isMiscCustomer
  } = stopData ?? {};

  const stopAddress = formatAddress({
    address,
    address2,
    city,
    state,
    zip
  });

  const openEditCustomer = () => {
    if (!customerCode || !enableCustomerLink) return;

    updateOrRemoveQueryParams({
      paramsToUpdate: {
        customerCode: customerCode
      },
      stateData: { closeOnRefresh: true, isHighZIndexRequired: true }
    });
  };

  const showCustomerLink = enableCustomerLink && customerCode && !isMiscCustomer;

  return (
    <div className={classes.stopDetailsContainer}>
      <div className={classes.stopHeaderContainer}>
        <span
          className={`${classes.stopName} ${showCustomerLink ? classes.showUnderLineText : ''}`}
          onClick={showCustomerLink ? openEditCustomer : null}>
          {stopName}
          <CustomerMergeIndicator displayCustomerName={stopName} customerName={name} />
          {isUnattendedDelivery && <UnattendedDelivery color={theme.palette.primary.main} />}
        </span>
        <span className={classes.stopName}>{showCustomerCode ? stopData.displayCustomerCode : driverNumber}</span>
      </div>
      <div>
        <span className={classes.stopAddress}>{stopAddress}</span>
      </div>
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(StopDetailsTitle);
